<template>
    <div class="bgFrame">
        <div :class="boxClass" style="z-index:500;">
            <img src="../../assets/home_banner2.png" class="bgImg" />
        </div>
        <div class="boxs" :style="'background-image: url(' + pointImg + ');'">
        </div>
        <div class="box" style="z-index:502;height: auto;overflow: visible;align-items: center;justify-content: flex-start;">
            <div class="textFrame">
                <div :class="topMessageClass">
                  <div style="margin-top:184px;"></div>
                    <div class="textTitle"><span style="color:#6891CC;">小</span><span style="color:#A089C4;">數</span><span style="color:#F5A440;">字</span>，大健康</div>
                    <div style="margin-top:5px;"></div>
                    <img src="../../assets/home_text_eng2.png" class="textImg" />
                </div>
                <div style="width:100%;margin-top: 107px;"></div>
                <div :class="bottomMessageClass">
                    NuMatch智能健康餐飲平台是專為用戶量身打造的AI智能平台。時刻關注用戶的健康管理，推廣以食代養的理念，有效運用科技數據方案實現個性化健康飲食推薦。<br><br> 我們對每份上架製品三大宏量營養素（卡路里、蛋白質、脂肪）及其他營養素成分含量進行專業檢測，实时共享數據至平台，每一份餐品均標有營養素含量數據及餐食克重，每一個小小的數字都與你大大的健康關係密切，讓你看得明白，食得放心，確保每餐多样化匹配身體所需。
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {ref, onMounted } from "vue";

export default {
  name: 'App',
  components: {
  },
  setup() {
    onMounted(() => {
    });
    let topMessageClass = ref('start_textSubFrame')
    let bottomMessageClass = ref('start_textContent')
    let boxClass = ref('box_normal')

    const startAnime = ref(false)
    const changeAnime = () =>{
        topMessageClass.value = 'start_textSubFrame'
        bottomMessageClass.value = 'start_textContent'
        boxClass.value = 'box_normal'
        if (startAnime.value == false) {
          setTimeout(() => {
            boxClass.value = 'box_anime'
            topMessageClass.value = 'textSubFrame'
            setTimeout(() => {
              bottomMessageClass.value = 'textContent'
            }, 400);
          }, 800);
        }
    }
    let pointImg = ref(require('../../assets/noise.png'))
    return {
      pointImg,
      boxClass,
        topMessageClass,
        bottomMessageClass,
        startAnime,
        changeAnime
    };
  },
}
</script>

<style scoped lang="less">
@keyframes boxAnime {
  from {
      opacity: 0;
  }
  to {
      opacity: 1;
  }
}
.box_anime{
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  opacity: 1;
  animation-duration: 2s;
  animation-name: boxAnime;
}

.box_normal{
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  opacity: 0;
}
.bgFrame{
    width: 100%;
    height: 100%;
    background: white;
    overflow: hidden;
}
.box{
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.bgImg{
  height: 100%;
  min-height: 878px;
  position: absolute;
  top: 0;
  object-fit: cover;
}

.textFrame{
  height: 100%;
  margin-left: calc((100% - 1100px) / 2);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}

@keyframes textSubAnime {
  from {
      transform: translate(0px, -60px);
      opacity: 0;
  }
  to {
      transform: translate(0px, 0px);
      opacity: 1;
  }
}
.textSubFrame{
    display: flex;
    
    flex-direction: column;
    justify-content: left;
    animation-name: textSubAnime;
    animation-duration: 1s;
}

.start_textSubFrame{
    opacity: 0;
    display: flex;
    flex-direction: column;
    justify-content: left;
}

.textTitle{
    font-size: 65px;
    font-family: MicrosoftYaHeiLight;
    color: #658343;
    text-align: left;
    line-height: 87px;
}
.textImg{
    width: 552px;
}
@keyframes textContentAnime {
  from {
      transform: translate(0px, 60px);
      opacity: 0;
  }
  to {
      transform: translate(0px, 0px);
      opacity: 1;
  }
}
.textContent{
  width: 613px;
    text-align: left;
    font-size: 16px;
    font-family: MicrosoftYaHeiLight;
    color: #243C05;
    animation-name: textContentAnime;
    animation-duration: 1s;
    opacity: 1;
}

.start_textContent{
  width: 613px;
    opacity: 0;
    text-align: left;
    font-size: 16px;
    font-family: MicrosoftYaHeiLight;
    color: #243C05;
}

@keyframes pointAnime{
  0% {
    transform: translate3d(0,9px,0)
  }
  10% {
    transform: translate3d(-1px,-4px,0)
  }
  20% {
    transform: translate3d(-8px,2px,0)
  }
  30% {
    transform: translate3d(-9px,-9px,0)
  }
  40% {
    transform: translate3d(2px,7px,0)
  }
  50% {
    transform: translate3d(9px,-4px,0)
  }
  60% {
    transform: translate3d(2px,6px,0)
  }
  70% {
    transform: translate3d(7px,-8px,0)
  }
  80% {
    transform: translate3d(-9px,1px,0)
  }
  90% {
    transform: translate3d(6px,-5px,0)
  }
  to {
    transform: translate3d(-7px,0,0)
  }
}
.boxs {
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 501;
  position: absolute;
  background-position:50%;
  animation :pointAnime 1.3s steps(2) infinite;
}


</style>
